import ValueGeneratorInterface from "./ValueGenerator/ValueGeneratorInterface"
import ValueInterface from "../Model/Value/ValueInterface"
import RandomNumberGenerator from "./RandomNumberGenerator"
import Fighter from "../Model/Fighter"
import FighterInterface from "../Model/FighterInterface"
import config from "../config.json"
import Game from "../Model/Game"
import { v4 } from "uuid"

export default class FighterGenerator {
  constructor(
    private readonly generators: ValueGeneratorInterface[],
    private readonly randomNumberGenerator: RandomNumberGenerator,
  ) {}

  public generate(
    value: number,
    type: "me" | "enemy",
    game?: Game,
  ): FighterInterface {
    const values: ValueInterface[] = this.generators
      .filter((generator: ValueGeneratorInterface): boolean =>
        generator.supports(value, game?.level ?? 1),
      )
      .map(
        (generator: ValueGeneratorInterface): ValueInterface =>
          generator.generate(value, game?.level ?? 1),
      )

    return new Fighter(
      v4(),
      type,
      this.randomNumberGenerator.pick<ValueInterface>(values),
      game === undefined ? "" : this.pickPosition(game),
      "idle",
    )
  }

  private pickPosition(game: Game): string {
    const occupiedPositions: string[] = game.enemies.map(
      (fighter: FighterInterface): string => fighter.position,
    )

    const availablePositions: string[] = []
    for (let i: number = 1; i <= config.maxEnemies; i++) {
      const p: string = `enemy-position-${i}`
      if (occupiedPositions.includes(p)) {
        continue
      }

      availablePositions.push(p)
    }
    return this.randomNumberGenerator.pick<string>(availablePositions)
  }
}
